module.exports = __webpack_public_path__ + "img/customer-a-078.682ddbd2.png";